import { useDispatch, useSelector } from 'react-redux';
import { setSessionExpired, setSpinnerLoading } from '../utility/Redux/modal';
import { useState } from 'react';
import { selectToken } from '../utility/Redux/security';
import { useEffect } from 'react';
import { selectCompanyAddress } from '../utility/Redux/profile';
import MasterHelp from '../utility/component/modals/masterHelp';
import { useNavigate } from 'react-router-dom';
import { CallAPIPromise } from '../routeBilling/menu/dashboard/biiling/modal/comman';
const WhatsappTemplatehelp = ({ onRowClick, status, onClose }) => {
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    height: '80%',
    width: 'auto',
    padding: '2px',
    borderRadius: '8px',
    // Change the shadow color
    overflow: 'hidden',
    backgroundColor: 'white',
  };

  const [rows, setRows] = useState([]);
  const token = useSelector(selectToken);

  const columns = [
    {
      field: 'product_name',
      renderHeader: (params) => <div>Product Name</div>,
      width: 290,
      headerAlign: 'center',
      align: 'left',
    },
    {
      field: 'messanger_id',
      renderHeader: (params) => <div>messanger ID</div>,
      width: 250,
      headerAlign: 'center',
      align: 'left',
    },
    {
      field: 'from_whatsapp_no',
      renderHeader: (params) => <div>Whatsapp No.</div>,
      width: 200,
      headerAlign: 'center',
      align: 'left',
    },
  ];
  const companyDetail = useSelector(selectCompanyAddress);
  console.log(companyDetail);
  const [searchQuery, setSearchQuery] = useState('');
  const [fullList, setFullList] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    if (searchQuery) {
      const regex = /\d+/;

      const searchItems = fullList.filter((item) => {
        if (regex.test(searchQuery.substring(0, 1))) {
          return item.product_name.toString().includes(searchQuery);
        } else {
          return item.product_name
            .toLowerCase()
            .includes(searchQuery.toLowerCase());
        }
      });

      setRows(searchItems);
    } else {
      setRows(fullList);
    }
  }, [searchQuery]);

  const dispatch = useDispatch();

  const getData = async () => {
    dispatch(setSpinnerLoading('Loading'));
    const data = {
      product_name: '',
    };
    CallAPIPromise(
      '/api/whatsAppSender/listWhatsAppSenderHelp',
      data,
      token,
      dispatch
    )
      .then((p) => {
        if (!p.data.error) {
          let list = [];
          const data = p.data.response;

          for (let i = 0; i < data.length; i++) {
            list.push({
              ...data[i],
              id: i + 1,
            });
          }
          setFullList(list);
          setRows(list);
        }
      })
      .catch((error) => {
        console.log(error);
        if (error.response.data.name === 'TokenExpiredError') {
          dispatch(setSessionExpired(true));
          console.log(error.response);
        }
      })
      .finally(() => {
        dispatch(setSpinnerLoading(false));
      });
  };

  useEffect(() => {
    if (status) {
      getData();
    }
  }, [status]);

  return (
    <>
      <div className="bg-white">
        <MasterHelp
          status={status}
          style={style}
          onClose={() => {
            onClose();
            setRows([]);
            setSearchQuery('');
          }}
          title={'Whastapp Sender | Help'}
          columns={columns}
          list={rows}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          onRowClick={(p) => {
            onRowClick(p);
            setRows([]);
          }}
          goToMaster={() => {
            navigate('/setting');
          }}
        />
      </div>
    </>
  );
};

export default WhatsappTemplatehelp;
